var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVehicleInfoActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#262D3C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3389 5.33325H12.5714C10.4164 5.33325 9.33894 5.33325 8.66947 6.02752C8 6.72178 8 7.83919 8 10.074V21.9258C8 24.1606 8 25.2781 8.66947 25.9723C9.33894 26.6666 10.4164 26.6666 12.5714 26.6666H19.4286C21.5836 26.6666 22.6611 26.6666 23.3305 25.9723C24 25.2781 24 24.1606 24 21.9258V12.241C24 11.7566 24 11.5143 23.913 11.2965C23.826 11.0787 23.6609 10.9075 23.3305 10.5649L18.9552 6.02752C18.6249 5.68496 18.4597 5.51369 18.2497 5.42347C18.0397 5.33325 17.8061 5.33325 17.3389 5.33325Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.3333L20 17.3333",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.3333L17.3333 21.3333",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3335 5.33325V9.7777C17.3335 10.8253 17.3335 11.349 17.6589 11.6745C17.9844 11.9999 18.5082 11.9999 19.5557 11.9999H24.0002",
    stroke: "white",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleInfoActive);
export default __webpack_public_path__ + "static/media/vehicle-info-active.6fb9682396727ba6453cc2cf19f2e72c.svg";
export { ForwardRef as ReactComponent };